/* eslint-disable */
import {
  Flex,
  Input,
  Modal,
  Select,
  Tag,
  DatePicker,
  Space,
  Tooltip,
  Badge,
  Dropdown,
  List,
  Button,
  message,
  Radio,
  Spin,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

import {
  FormOutlined,
  MenuOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  HistoryOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { dataTo12Fn } from "@/utils/date.js";
import { useLocation } from "react-router-dom";

const { RangePicker } = DatePicker;

// ==================== 常量配置 ====================
const STATUS_MAP = {
  Pending: { color: "#dd4b39", label: "Pending" },
  Quoted: { color: "#dd4b39", label: "Quoted" },
  Assigned: { color: "#dd4b39", label: "Assigned" },
  Approved: { color: "#dd4b39", label: "Approved" },
  Review: { color: "#dd4b39", label: "Review" },
  "Ready To Pay": { color: "#00a65a", label: "Ready To Pay" },
  "Document Only": { color: "#3c8dbc", label: "Document Only" },
};

const WORK_TYPE_MAP = {
  1: "Maint.Woker",
  2: "Contractor",
};

const MATERIAL_MAP = {
  1: "Yes",
  2: "No",
};

const REQUEST_BY_MAP = {
  1: "Tenant",
  2: "Manager",
};

const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "Pending", label: "Pending" },
  { value: "Assigned", label: "Assigned" },
  { value: "Quoted", label: "Quoted" },
  { value: "Approved", label: "Approved" },
  { value: "Review", label: "Review" },
];

const WORK_TYPE_OPTIONS = [
  { value: "", label: "All" },
  { value: "1", label: "Maint.Woker" },
  { value: "2", label: "Contractor" },
];

const MATERIAL_OPTIONS = [
  { value: "", label: "All" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

const REQUEST_BY_OPTIONS = [
  { value: "", label: "All" },
  { value: "1", label: "Tenant" },
  { value: "2", label: "Manager" },
];

// ==================== 主组件 ====================
const PUTTable = forwardRef((props, ref) => {
  const location = useLocation();
  const idParamsRef = useRef(null);
  const initialLoad = useRef(false);

  // ===== State =====
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [tableList, setTableList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [columns, setColumns] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [pickerDates, setPickerDates] = useState(null);
  const [predictedDates, setPredictedDates] = useState(null);

  const initTableHead = {
    status: null,
    prop: null,
    workType: null,
    propUnit: null,
    address: null,
    city: null,
    job: null,
    remark: null,
    requestBy: null,
    createByName: null,
    requestNo: null,
    vendorName: null,
    sCreateTime: null,
    sCompletionDate: null,
    eCreateTime: null,
    eCompletionDate: null,
    requestByName: null,
    ids: null,
    groupSupervisor: null,
    type: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  // ===== Review Materials Modal 状态 =====
  const [reviewMaterialsModal, setReviewMaterialsModal] = useState(false);
  const [reviewMaterialsList, setReviewMaterialsList] = useState([]);
  const [reviewMaterialsLoading, setReviewMaterialsLoading] = useState(false);
  const [currentMaintenanceId, setCurrentMaintenanceId] = useState(null);

  // ===== Approval Modal 状态 =====
  const [approvalState, setApprovalState] = useState({
    id: null,
    reviewStatus: "2",
    rejectReason: "",
  });
  const [approvalModal, setApprovalModal] = useState(false);

  // ===== Clock Modal 状态 =====
  const [clockList, setClockList] = useState([]);
  const [closkModal, setCloskModal] = useState(false);
  const [clockLoading, setClockLoading] = useState(false);
  const [currentClockId, setCurrentClockId] = useState(null);

  // ===== 字段映射 =====
  const fieldMap = {
    jobs: "job",
  };

  // ===== 工具函数 =====
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // ===== 日期处理 =====
  const handleDateOk = (dates, confirm, startKey, endKey) => {
    if (dates && dates.length === 2) {
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();
      setTableHead((prev) => {
        const updated = { ...prev, [startKey]: startTime, [endKey]: endTime };
        getTableListFn(1, pagination.pageSize, updated);
        return updated;
      });
      if (confirm) confirm();
    }
  };

  const handleDateReset = (setDates, startKey, endKey, clearFilters) => {
    clearFilters?.();
    setDates([]);
    setTableHead((prev) => {
      const updated = { ...prev, [startKey]: "", [endKey]: "" };
      getTableListFn(1, pagination.pageSize, updated);
      return updated;
    });
  };

  // ===== Select 处理函数 =====
  const handleStatusChange = (value) => {
    setTableHead((prev) => {
      const updated = { ...prev, status: value };
      getTableListFn(1, 25, updated);
      return updated;
    });
  };

  const handleWorkTypeChange = (value) => {
    setTableHead((prev) => {
      const updated = { ...prev, workType: value };
      getTableListFn(1, 25, updated);
      return updated;
    });
  };

  const handleMaterialChange = (value) => {
    setTableHead((prev) => {
      const updated = { ...prev, isMaterials: value };
      getTableListFn(1, 25, updated);
      return updated;
    });
  };

  const handleRequestByNameChange = (value) => {
    setTableHead((prev) => {
      const updated = { ...prev, requestByName: value };
      getTableListFn(1, 25, updated);
      return updated;
    });
  };

  // ===== Render 辅助函数 =====
  const renderStatus = (text, record) => {
    const status = STATUS_MAP[text] || { color: "#ddd", label: text || " " };
    return (
      <a onClick={() => showModalOpen(record)}>
        <Tag color={status.color}>{status.label}</Tag>
      </a>
    );
  };

  const renderWorkType = (text) => {
    if (text === null || text === undefined) return " ";
    return WORK_TYPE_MAP[text] || " ";
  };

  const renderMaterial = (text) => {
    if (text === null || text === undefined) return " ";
    return MATERIAL_MAP[text] || " ";
  };

  const renderJobs = (text, record) => (
    <Flex gap="4px 0" wrap>
      {record.jobs?.map((item, idx) => (
        <Tooltip title={item} key={idx}>
          <Tag
            color="rgba(109, 140, 81, 0.12)"
            style={{
              color: "#6D8C51",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item}
          </Tag>
        </Tooltip>
      ))}
    </Flex>
  );

  const renderRemark = (text) => (
    <Tooltip title={text}>
      <div className="text-clamp" style={{ whiteSpace: "normal", width: "100px" }}>
        {text}
      </div>
    </Tooltip>
  );

  // ===== 列定义 =====
  const initColumns = [
    {
      title: "#",
      key: "#",
      dataIndex: "#",
      hidden: false,
      align: "center",
      width: 50,
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => (
        <Badge count={record.messageCount} offset={[6, -6]} size="small">
          <Dropdown
            menu={{
              items: [
                {
                  key: "ReviewMaterials",
                  icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: "Review Materials",
                },
                {
                  key: "InvoiceJobHistory",
                  icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: "Invoice Job History",
                },
              ],
              onClick: (e) => badgeFn(record, e),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        </Badge>
      ),
    },
    {
      title: "Request No",
      dataIndex: "requestNo",
      key: "requestNo",
      hidden: false,
      width: 110,
      align: "center",
      isSorter: true,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "requestNo"),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Status</div>
          <div>
            <Select
              value={tableHead.status}
              defaultValue="All"
              placeholder="Select status"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={handleStatusChange}
              options={STATUS_OPTIONS}
            />
          </div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      hidden: false,
      width: 110,
      className: "custom-sort-header",
      sorter: true,
      render: renderStatus,
    },
    {
      title: "Created Time",
      dataIndex: "createTime",
      key: "createTime",
      width: 250,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={pickerDates}
            onChange={(dates) => {
              setPickerDates(dates);
              handleDateOk(dates, confirm, "sCreateTime", "eCreateTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleDateReset(setPickerDates, "sCreateTime", "eCreateTime", clearFilters)
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
    {
      title: "Invoice Count",
      dataIndex: "invoiceCount",
      key: "invoiceCount",
      hidden: false,
      width: 110,
      align: "center",
      isSorter: true,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "invoiceCount"),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      key: "jobs",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobs"),
      render: renderJobs,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
      render: renderRemark,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Material</div>
          <div>
            <Select
              value={tableHead.isMaterials}
              defaultValue="All"
              placeholder="Select Material"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={handleMaterialChange}
              options={MATERIAL_OPTIONS}
            />
          </div>
        </div>
      ),
      dataIndex: "isMaterials",
      key: "isMaterials",
      align: "center",
      hidden: false,
      width: 110,
      sorter: (a, b) => {
        if (a.isMaterials == null && b.isMaterials == null) return 0;
        if (a.isMaterials == null) return 1;
        if (b.isMaterials == null) return -1;
        return a.isMaterials - b.isMaterials;
      },
      className: "custom-sort-header",
      render: renderMaterial,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Vendor Type</div>
          <div>
            <Select
              value={tableHead.workType}
              defaultValue="All"
              placeholder="Select status"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={handleWorkTypeChange}
              options={WORK_TYPE_OPTIONS}
            />
          </div>
        </div>
      ),
      dataIndex: "workType",
      key: "workType",
      align: "center",
      hidden: false,
      width: 110,
      sorter: (a, b) => {
        if (a.workType == null && b.workType == null) return 0;
        if (a.workType == null) return 1;
        if (b.workType == null) return -1;
        return a.workType - b.workType;
      },
      className: "custom-sort-header",
      render: renderWorkType,
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Predicted Date",
      dataIndex: "completionDate",
      key: "completionDate",
      width: 150,
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={predictedDates}
            onChange={(dates) => {
              setPredictedDates(dates);
              handleDateOk(dates, confirm, "sCompletionDate", "eCompletionDate");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleDateReset(setPredictedDates, "sCompletionDate", "eCompletionDate", clearFilters)
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Unit Address",
      dataIndex: "address",
      key: "address",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "address"),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "city"),
    },
    {
      title: "Supervisor",
      dataIndex: "groupSupervisor",
      key: "groupSupervisor",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "groupSupervisor"),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Requested By</div>
          <div>
            <Select
              value={tableHead.requestByName}
              defaultValue="All"
              placeholder="Select status"
              style={{ width: 90 }}
              onClick={(e) => e.stopPropagation()}
              onChange={handleRequestByNameChange}
              options={REQUEST_BY_OPTIONS}
            />
          </div>
        </div>
      ),
      dataIndex: "requestByName",
      key: "requestByName",
      align: "center",
      hidden: false,
      width: 100,
      sorter: (a, b) => {
        if (a.requestByName == null && b.requestByName == null) return 0;
        if (a.requestByName == null) return 1;
        if (b.requestByName == null) return -1;
        return a.requestByName - b.requestByName;
      },
      className: "custom-sort-header",
      render: (text) => text,
    },
    {
      title: "Create By",
      dataIndex: "createByName",
      key: "createByName",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "createByName"),
    },
  ];

  // ===== 业务函数 =====

  // ===== Review Materials =====
  const reviewMaterialsModalFn = async ({ id }) => {
    setReviewMaterialsModal(true);
    setReviewMaterialsLoading(true);
    setCurrentMaintenanceId(id);
    setReviewMaterialsList([]);

    try {
      const response = await http.get(
        `${api.showMaterialsByMaintenanceId}?maintenanceId=${id}`
      );
      if (response.code === "1") {
        setReviewMaterialsList(response.data || []);
      } else {
        message.error(response.msg || "Failed to fetch materials");
      }
    } catch (err) {
      console.error("Error fetching materials:", err);
      message.error("Failed to fetch materials");
    } finally {
      setReviewMaterialsLoading(false);
    }
  };

  // ===== Invoice Job History =====
  const invoiceJobHistoryFn = async ({ id }) => {
    setCloskModal(true);
    setClockLoading(true);
    setCurrentClockId(id);
    setClockList([]);

    try {
      const response = await http.get(`${api.getClockList}?maintenanceId=${id}`);
      if (response.code === "1") {
        setClockList(response.data || []);
      } else {
        message.error(response.msg || "Failed to fetch history");
      }
    } catch (err) {
      console.error("Error fetching clock history:", err);
      message.error("Failed to fetch history");
    } finally {
      setClockLoading(false);
    }
  };

  // ===== Approval 相关 =====
  const approvalFn = (item) => {
    setApprovalState({
      ...approvalState,
      id: item.id,
      maintenanceId: item.maintenanceId,
    });
    setApprovalModal(true);
  };

  const approvalSubmitFn = async () => {
    const response = await http.post(`${api.reviewMaterials}`, approvalState);
    if (response.code === "1") {
      // 刷新 Review Materials 列表
      if (currentMaintenanceId) {
        await reviewMaterialsModalFn({ id: currentMaintenanceId });
      }
    } else {
      Modal.confirm({
        title: null,
        content: response.msg,
        footer: null,
        closable: true,
        maskClosable: true,
      });
    }
    approvalModalCancel();
  };

  const approvalModalCancel = () => {
    setApprovalModal(false);
    setApprovalState({
      id: null,
      reviewStatus: "2",
      rejectReason: "",
    });
  };

  // ===== Modal 关闭时重置状态 =====
  const handleReviewMaterialsClose = () => {
    setReviewMaterialsModal(false);
    setReviewMaterialsList([]);
    setReviewMaterialsLoading(false);
    setCurrentMaintenanceId(null);
  };

  const handleClockClose = () => {
    setCloskModal(false);
    setClockList([]);
    setClockLoading(false);
    setCurrentClockId(null);
  };

  const badgeFn = (record, item) => {
    const fnMatch = {
      ReviewMaterials: reviewMaterialsModalFn,
      InvoiceJobHistory: invoiceJobHistoryFn,
    };
    if (fnMatch[item.key]) {
      fnMatch[item.key](record);
    }
  };

  const showModalOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance/Details";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // ===== 行选择配置 =====
  const rowSelection = {
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {},
      disabled:
        record.status !== "Pending" ||
        (record.status === "Quoted" && materials_confirm_type === 2),
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
      props.deleteNum?.(selectedRows);
    },
  };

  // ===== 获取列表数据 =====
  const getTableListFn = async (page, pageSize, params = {}) => {
    try {
      setTableLoading(true);

      const hash = window.location.hash;
      const queryStart = hash.indexOf("?");
      let ids = null;
      let statusFilterFromUrl = null;

      if (queryStart !== -1) {
        const queryString = hash.substring(queryStart + 1);
        const searchParams = new URLSearchParams(queryString);
        ids = searchParams.get("ids");
        statusFilterFromUrl = searchParams.get("statusFilter");
      }

      const currentIdParams = idParamsRef.current || {};
      const queryParams = {
        page,
        count: pageSize,
        orderField: params.orderField || "",
        orderType: params.orderType || "",
        ...currentIdParams,
        type: params.status || tableHead.status || "",
        prop: params.prop || tableHead.prop || "",
        workType: params.workType || tableHead.workType || "",
        propUnit: params.propUnit || tableHead.propUnit || "",
        address: params.address || tableHead.address || "",
        city: params.city || tableHead.city || "",
        job: params.jobs || tableHead.jobs || "",
        remark: params.remark || tableHead.remark || "",
        requestBy: params.requestBy || tableHead.requestBy || "",
        createBy: params.createByName || tableHead.createByName || "",
        requestNo: params.requestNo || tableHead.requestNo || "",
        vendorName: params.vendorName || tableHead.vendorName || "",
        sCreateTime: params.sCreateTime || tableHead.sCreateTime || "",
        sCompletionDate: params.sCompletionDate || tableHead.sCompletionDate || "",
        eCreateTime: params.eCreateTime || tableHead.eCreateTime || "",
        eCompletionDate: params.eCompletionDate || tableHead.eCompletionDate || "",
        requestByName: params.requestByName || tableHead.requestByName || "",
        groupSupervisor: params.groupSupervisor || tableHead.groupSupervisor || "",
        status: params.status || tableHead.status || "",
        ...(ids ? { ids } : {}),
        ...(statusFilterFromUrl ? { status: statusFilterFromUrl } : {}),
      };

      const filteredParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
      );

      const response = await http.get(`${api.getContractorShow}`, {
        params: filteredParams,
      });

      if (response.code === "1") {
        const dataWithKey = (response.data.list || [])?.map((item) => ({
          ...item,
          key: item.id,
        }));
        setTableList(dataWithKey);
        setPagination((prev) => ({
          ...prev,
          current: page,
          total: response.data.total,
          pageSize: pageSize,
        }));
      } else {
        message.error(response.msg);
      }
    } catch (err) {
      console.error("Error:", err);
      message.error("Failed to fetch data");
    } finally {
      setTableLoading(false);
    }
  };
  // ===== 表格变化处理 =====
  const handleTableChange = (newPagination, filters, sorter) => {
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
      orderField = fieldMap[sorter.field] || sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    getTableListFn(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };

  // ===== URL 参数处理 =====
  const handleUrlParams = async (type, params) => {
    if (type === "Prop" && params.propId) {
      idParamsRef.current = { propId: params.propId };
    } else if (type === "Unit" && params.propId && params.unitId) {
      idParamsRef.current = { propId: params.propId, unitId: params.unitId };
    } else if (type === "Tenant" && params.propId && params.unitId && params.tenantId) {
      idParamsRef.current = {
        propId: params.propId,
        unitId: params.unitId,
        tenantId: params.tenantId,
      };
    } else {
      return;
    }
    await getTableListFn(1, pagination.pageSize, {});
  };

  // ===== 暴露方法 =====
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prev) =>
        prev.map((col) =>
          checkedValues.includes(col.key)
            ? { ...col, hidden: false }
            : { ...col, hidden: true }
        )
      );
    },
    getSearchValues: () => ({ ...tableHead }),
    newListFun: () => {
      setTableHead(initTableHead);
      setPickerDates(null);
      setPredictedDates(null);
      getTableListFn(1, 25, initTableHead);
      setRefreshKey((prev) => prev + 1);
    },
  }));

  // ===== Effects =====
  useEffect(() => {
    if (!initialLoad.current) {
      initialLoad.current = true;
      const hash = window.location.hash;
      const queryStart = hash.indexOf("?");

      if (queryStart !== -1) {
        const queryString = hash.substring(queryStart + 1);
        const searchParams = new URLSearchParams(queryString);
        const type = searchParams.get("type");
        const propId = searchParams.get("propId");
        const unitId = searchParams.get("unitId");
        const tenantId = searchParams.get("tenantId");

        if (type && (propId || unitId || tenantId)) {
          handleUrlParams(type, { propId, unitId, tenantId });
        }
      }
    }
  }, [location.hash]);

  useEffect(() => {
    const updatedColumns = initColumns.map((col) => {
      if (col.dataIndex === "#") {
        return {
          ...col,
          render: (text, record, index) =>
            (pagination.current - 1) * pagination.pageSize + index + 1,
        };
      }
      return col;
    });
    setColumns(updatedColumns);
  }, [pagination]);

  return (
    <div
      style={{
        padding: "30px",
      }}
    >
      <CustomTable
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="250px"
        tableCss="maintenanceTable"
        setTableHead={setTableHead}
        getTableListFn={getTableListFn}
        rowKey="id"
      />
      <Modal
        width="40%"
        title="Review Materials"
        className="reviewMaterialsModal"
        footer={null}
        open={reviewMaterialsModal}
        onCancel={handleReviewMaterialsClose}
        destroyOnClose
      >
        <Spin spinning={reviewMaterialsLoading} tip="Loading...">
          <List
            header={null}
            footer={null}
            split={true}
            className="review-materials-list"
            dataSource={reviewMaterialsList}
            locale={{ emptyText: "No materials found" }}
            renderItem={(item) => (
              <List.Item className="review-materials-item">
                <div className="RM-top">
                  <div className="RM-left">
                    <div>Pick-Up Location:</div>
                    <Input.TextArea autoSize disabled value={item.storeName} />
                    <div>MaterialsRemark:</div>
                    <Input.TextArea autoSize disabled value={item.materialsRemark} />
                  </div>
                  <div className="RM-right">
                    <div className="RM-icon">
                      {item.reviewStatus === 2 && (
                        <CheckOutlined style={{ color: "#18bc37" }} />
                      )}
                      {item.reviewStatus === 3 && (
                        <CloseOutlined style={{ color: "#ff0000" }} />
                      )}
                    </div>
                    <div>
                      {item.reviewStatus === 1 ? (
                        <div className="ApprovalBtn">
                          <div>Waiting For Approval</div>
                          {item.reviewStatus === 1 && (
                            <div className="RM-btn">
                              <Button type="primary" onClick={() => approvalFn(item)}>
                                Approval
                              </Button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <div>{item.reviewByName}</div>
                          <div>{dataTo12Fn(item.reviewTime, 2)}</div>
                          <div>{dataTo12Fn(item.reviewTime, 3)}</div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Spin>
      </Modal>

      {/* ===== Approval Modal ===== */}
      <Modal
        width="40%"
        title="Do You Agree"
        footer={null}
        open={approvalModal}
        onCancel={approvalModalCancel}
        destroyOnClose
      >
        <Radio.Group
          value={approvalState.reviewStatus}
          options={[
            { value: "2", label: "agree" },
            { value: "3", label: "refuse" },
          ]}
          onChange={(e) =>
            setApprovalState({ ...approvalState, reviewStatus: e.target.value })
          }
        />
        {approvalState.reviewStatus === "3" && (
          <div style={{ display: "flex", alignItems: "center", marginTop: "12px" }}>
            <span>Reason：</span>
            <Input.TextArea
              autoSize
              value={approvalState.rejectReason}
              onChange={(e) =>
                setApprovalState({
                  ...approvalState,
                  rejectReason: e.target.value,
                })
              }
              placeholder="input rejectReason"
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <Button type="primary" onClick={approvalSubmitFn}>
            Submit
          </Button>
        </div>
      </Modal>

   
      <Modal
        width="40%"
        title="Invoice Job History"
        footer={null}
        open={closkModal}
        onCancel={handleClockClose}
        destroyOnClose
      >
        <Spin spinning={clockLoading} tip="Loading ...">
          <div className="IJH-list">
            {clockList.length ? (
              clockList.map((item) => (
                <div key={item.id} className="IJH-item">
                  <span>Time: </span>
                  <span className="IJH-time">{dataTo12Fn(item.clockTime)}</span>
                </div>
              ))
            ) : (
              <div className="IJH-noData">No data</div>
            )}
          </div>
          <div className="IJH-btn">
            <Button type="primary" onClick={handleClockClose}>
              Close
            </Button>
          </div>
        </Spin>
      </Modal>

  
    </div>
  );
});

export default PUTTable;